export default "__VITE_ASSET__DL_GM8dq__"